import { render, staticRenderFns } from "./CustomerImportSummary.vue?vue&type=template&id=5583b1e0&scoped=true"
import script from "./CustomerImportSummary.vue?vue&type=script&lang=js"
export * from "./CustomerImportSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5583b1e0",
  null
  
)

export default component.exports